import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import { updateUser } from '../firebase/firebase';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ShipModal = ({ visible, onClose, uid, email, language }) => {
  const [trackingLink, setTrackingLink] = useState('');
  const [startDate, setStartDate] = useState(new Date());

  const handleSubmit = async () => {
    try {
      const url =
        'https://memowrite.app.n8n.cloud/webhook/2a9b50c6-5fe8-47cb-ad67-e685c186dc27';
      const dataToSend = {
        email,
        tracking_link: trackingLink,
        language,
      };

      await fetch(url, {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      });

      await updateUser({
        uid,
        data: {
          tracking_link: trackingLink,
          ship_book: Math.round(startDate.getTime()) / 1000,
        },
        email,
      });
    } catch (e) {
      console.error(e);
    } finally {
      onClose();
    }
  };

  return (
    <Modal show={visible} onHide={onClose} centered>
      <Modal.Header closeButton style={{ border: 'none' }}>
        <Modal.Title>Book shipping info</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>Tracking link</Form.Label>
        <InputGroup>
          <Form.Control
            aria-label="Default"
            aria-describedby="inputGroup-sizing-default"
            value={trackingLink}
            onChange={(e) => setTrackingLink(e.target.value)}
          />
        </InputGroup>
        <Col className="mt-4">
          <Form.Label>Print date</Form.Label>
          <InputGroup>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
            />
          </InputGroup>
        </Col>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={!trackingLink || !startDate}
          variant="dark"
          className="button-update"
          onClick={handleSubmit}
        >
          Submit
        </Button>
        <Button
          variant="outline-dark"
          className="button-update"
          onClick={onClose}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShipModal;
